import { render, staticRenderFns } from "./inquiriesHead.vue?vue&type=template&id=4dbf5bed&scoped=true"
import script from "./inquiriesHead.vue?vue&type=script&lang=js"
export * from "./inquiriesHead.vue?vue&type=script&lang=js"
import style0 from "./inquiriesHead.vue?vue&type=style&index=0&id=4dbf5bed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf5bed",
  null
  
)

export default component.exports